import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';
import './index.scss';

const cx = classNames.bind('./index.scss');

export interface ButtonGroupProps extends HTMLAttributes<HTMLDivElement> {}

const ButtonGroup = ({
  children,
  className,
  ...props
}: React.PropsWithChildren<ButtonGroupProps>): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={className || cx('buttonGroupWrapper')} {...props}>
      {children}
    </div>
  );
};

export default React.memo(ButtonGroup);
